const ImageSlide = ({ key, url, orientation }) => (
  <div>
    <img style={{ aspectRatio: (orientation === 'portrait' ? '9/16' : '16/9') }} src={url} alt={key} />
  </div>
);

export default ImageSlide;
